export const SET_LOAD_CATEGORIES_STATE = 'SET_LOAD_CATEGORIES_STATE';

export default function setLoadCategories(payload) {
  return {
    type: SET_LOAD_CATEGORIES_STATE,
    payload,
  };
}
